import(/* webpackMode: "eager", webpackExports: ["Poll"] */ "/vercel/path0/web/components/article/poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/vercel/path0/web/components/article/reading-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RevealFaq"] */ "/vercel/path0/web/components/article/reveal-faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZoneCarousel"] */ "/vercel/path0/web/components/article/zone-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/vercel/path0/web/components/sections/share-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/web/components/sections/table-of-contents.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
